import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/opt/buildhome/repo/middleware/auth.global.ts";
import i18n_45loader_45global from "/opt/buildhome/repo/middleware/i18n-loader.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  i18n_45loader_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "permissions-middl": () => import("/opt/buildhome/repo/middleware/permissionsMiddl.ts")
}